import type { EnrichedOrderWithPayment } from '@marxbiotech/shared-types/bff';

// Client-side best-effort 預檢，避免送出注定失敗的 cancel 請求。
// 真正的權威在 BFF / medusajs-core 的 cancelOrderWorkflow guard；
// 若此函式落後於後端規則，最差情況是按鈕可點但 API 回錯、不會造成資料不一致。
export const isOrderCancelable = (
  order: EnrichedOrderWithPayment
): boolean => {
  if (order.status === 'canceled' || order.status === 'completed') {
    return false;
  }

  const fulfillments = order.fulfillments ?? [];
  const hasActiveFulfillments = fulfillments.some(
    (fulfillment) => !fulfillment.canceled_at
  );
  if (hasActiveFulfillments) {
    return false;
  }

  return true;
};
